import { z } from 'zod'

export const stpSearchSchema = z.object({
  view: z.enum(['grid', 'list']).optional().catch('grid'),
  folder: z.string().optional().catch(undefined),
  q: z.string().optional(),
  authorId: z.string().optional(),
  colorway: z.string().optional(),
  collection: z.string().optional(),
  gender: z.string().optional(),
  mainGroup: z.string().optional(),
  subGroup: z.string().optional(),
  category: z.string().optional(),
  attrs: z.record(z.string(), z.string()).optional().catch(undefined),
  tags: z.array(z.uuid()).optional().catch(undefined),
  approval: z.enum(['approved', 'denied', 'pending']).optional(),
})

export type STPSearchParams = z.infer<typeof stpSearchSchema>
